import { render, staticRenderFns } from "./AppointmentNotification.vue?vue&type=template&id=581d563c&"
import script from "./AppointmentNotification.vue?vue&type=script&lang=ts&"
export * from "./AppointmentNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports